export function toErrorMessage(reason, fallback) {
    if (reason instanceof Error && reason.message.trim()) {
        return reason.message;
    }
    if (typeof reason === "string" && reason.trim()) {
        return reason;
    }
    return fallback;
}
export function extractHtmlError(html, fallback = "") {
    const documentNode = new DOMParser().parseFromString(html, "text/html");
    const message = Array.from(documentNode.querySelectorAll(".validation-summary-errors, .field-validation-error"))
        .map((element) => element.textContent?.trim())
        .filter((value) => Boolean(value))
        .join("\n");
    return message || fallback;
}
export function normalizeHtmlError(reason, fallback) {
    const message = toErrorMessage(reason, fallback);
    return message.includes("<") ? extractHtmlError(message, fallback) : message;
}
